import {useEffect, useState} from "react";
import {logger} from "../../../services/log/logger";
import {getOrientation} from "../../../util/screenUtil";

/**
 * This file defines a custom React hook named `useScreenOrientation`. This hook is used to determine and track the
 * screen orientation of the device (either "portrait" or "landscape"). It provides the following functionalities:
 *
 * 1. **Determine Initial Orientation**: It determines the initial screen orientation when the component mounts.
 * 2. **Track Orientation Changes**: It sets up an event listener to track changes in screen orientation and updates
 *    the state accordingly.
 * 3. **Logging**: It logs the orientation changes for debugging purposes.
 *
 * The hook returns the current screen orientation, allowing components to respond to changes in device orientation.
 */

export default function useScreenOrientation() {
  const [orientation, setOrientation] = useState(getOrientation())
  useEffect(() => {
    function handleChange() {
      setTimeout(()=>{ //on chrome the dimensions don't update immediately, so wait 10ms.
        const newOrientation = getOrientation();
        logger.deviceScreen.info({
          message: `orientation change.`,
          data: [
            { key: "Old orientation", value: orientation },
            { key: "New orientation", value: newOrientation }
          ]
        });
        setOrientation(newOrientation);
      }, 10);

    }
    //resize doesn't always fire, particularly after going from portrait, landscape, then back to portrait.
    // window.addEventListener('resize', handleChange);
    // return () => window.removeEventListener('resize', handleChange);
    window.addEventListener('orientationchange', handleChange);
    return () => window.removeEventListener('orientationchange', handleChange);
  }, [orientation]);

  return orientation;
}